/*eslint-disable*/
import React from 'react'
import DeleteIcon from '@material-ui/icons/Delete'
import IconButton from '@material-ui/core/IconButton'
// react components for routing our app without refresh
import { Link } from 'react-router-dom'

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import Tooltip from '@material-ui/core/Tooltip'

// @material-ui/icons
import BusinessIcon from '@material-ui/icons/Business'
import GroupIcon from '@material-ui/icons/Group'
import DescriptionIcon from '@material-ui/icons/Description'
import LocalLibraryIcon from '@material-ui/icons/LocalLibrary'
import LocalPhoneIcon from '@material-ui/icons/LocalPhone'

// core components
import CustomDropdown from 'components/CustomDropdown/CustomDropdown.js'
import Button from 'components/CustomButtons/Button.js'

import styles from 'assets/jss/material-kit-react/components/myHeaderLinksStyle.js'
import CompanyPage from 'views/CompanyPage/CompanyPage'

const useStyles = makeStyles(styles)

export default function HeaderLinks(props) {
  const classes = useStyles()
  return (
    <List className={classes.list}>
      {/* <ListItem className={classes.listItem}>
        <CustomDropdown
          noLiPadding
          buttonText="Components"
          buttonProps={{
            className: classes.navLink,
            color: 'transparent',
          }}
          buttonIcon={Apps}
          dropdownList={[
            <Link to="/" className={classes.dropdownLink}>
              All components
            </Link>,
            <a
              href="https://creativetimofficial.github.io/material-kit-react/#/documentation?ref=mkr-navbar"
              target="_blank"
              className={classes.dropdownLink}
            >
              Documentation
            </a>,
          ]}
        />
      </ListItem> */}
      <ListItem className={classes.listItem}>
        <Link to="company" className={classes.navLinkItem}>
          <Button color="transparent" className={classes.navLink}>
            <BusinessIcon className={classes.leftIcon} />
            企业概况
          </Button>
        </Link>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Link to="service" className={classes.navLinkItem}>
          <Button color="transparent" className={classes.navLink}>
            <GroupIcon className={classes.leftIcon} />
            服务类型
          </Button>
        </Link>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Link to="case" className={classes.navLinkItem}>
          <Button color="transparent" className={classes.navLink}>
            <DescriptionIcon className={classes.leftIcon} />
            典型案例
          </Button>
        </Link>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Link to="culture" className={classes.navLinkItem}>
          <Button color="transparent" className={classes.navLink}>
            <LocalLibraryIcon className={classes.leftIcon} />
            企业文化
          </Button>
        </Link>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Link to="contact" className={classes.navLinkItem}>
          <Button color="transparent" className={classes.navLink}>
            <LocalPhoneIcon className={classes.leftIcon} />
            联系我们
          </Button>
        </Link>
      </ListItem>
    </List>
  )
}
